module.exports = __webpack_public_path__ + "static/media/18ECA7.e0294167.jpg";